import type { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { UserService } from '@core/auth/user/user.service';
import { environment } from 'src/environments/environment';

export const apiRequestTokenInterceptor: HttpInterceptorFn = (req, next) => {

  // Base body for all outgoing requests
  const defaultBody = {
    token: environment.staticToken,
    access_mode: environment.access_mode,
  };

  // Collect Authorization header from user session (if exists)
  const headers: Record<string, string> = {};
  const sessionToken = inject(UserService).getPartialData('loginsession');
  if (sessionToken) {
    headers['Authorization'] = String(sessionToken);
  }

  // Merge user-provided body with defaultBody
  let finalBody: any;

  if (req.body instanceof FormData) {
    const merged = new FormData();
    // Add defaults first
    Object.entries(defaultBody).forEach(([key, value]) => merged.append(key, value));
    // Add original form data
    req.body.forEach((value: any, key: string) => merged.append(key, value));
    finalBody = merged;
  } else if (req.body && typeof req.body === 'object') {
    finalBody = { ...defaultBody, ...req.body };
  } else {
    // No body → just use defaultBody
    finalBody = { ...defaultBody };
  }

  // ✅ Clone request with merged headers & body
  const newReq = req.clone({
    setHeaders: headers,
    body: finalBody,
  });

  return next(newReq);
};
